import React, {useState} from 'react';
import {useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import {loginSchema} from '../../../components/utilities/models/gen-models';
import {useNavigate} from 'react-router-dom';
import axios from '../../../components/utilities/axios';
import '../login/loginStyles.css'
import {
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput, CImage,
  CInputGroup,
  CInputGroupText,
  CRow
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import {cilLockLocked, cilUser} from '@coreui/icons';
import cobwebimg from '../../../assets/images/oga-app-logo2.png';

const OgaAppLogin = () => {
  const {register, handleSubmit,formState, formState: { errors }, reset} = useForm({
    resolver: yupResolver(loginSchema),
  });
  const { isSubmitting } = formState;
  const [loginError, setLoginError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [passwordShown, setPasswordShown] = useState(false);
  const [networkError, setNetworkError] = useState(null);
  // const [accessToken, setAccessToken] = useState('');
  const history = useNavigate();

  const handleLogin = async (details) => {
    await spinnerHandler();
    try {
      const {data} = await axios.post('/registrations/ogaAccessApp', details);

      if (data.success) {
        await window.localStorage.setItem('y-z-main', 'true');
        await window.localStorage.setItem('y-z-access', data.token);
        // console.log('accessToken->>>>', login.data.token);
        // console.log('data login->>>>', data);
        localStorage.setItem('userId', data.userDetails.ogaId);
        localStorage.setItem('userData', JSON.stringify(data.userDetails));
        history(
          '/dashboard',
          {state: {...data}}
        );
      } else {
        setLoginError(true);
        setErrorMessage(data.message);
      }
    } catch (e) {
      console.log(e)
      setNetworkError(e)
    }

  }

  // Password toggle handler
  const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown);
  };
  function spinnerHandler() {
    // return promise that resolves after 2 seconds
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 1000);
    });
  }
  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={7}>
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm onSubmit={handleSubmit(handleLogin)}>
                    <h2 className="fw-bold" style={{color: '#33C3E9'}}>OGA APP</h2>
                    <p className="text-medium-emphasis">Sign In to your account</p>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilUser} />
                      </CInputGroupText>
                      <CFormInput type="email" name="emailAddress" placeholder="email address" autoComplete="username" {...register("emailAddress")}/>
                    </CInputGroup>
                    <div className="text-danger small mt-2">{errors.emailAddress?.message}</div>
                    <CInputGroup className="mb-4">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type={passwordShown ? "text" : "password"}
                        placeholder="Password"
                        autoComplete="current-password"
                        {...register("password")}
                      />
                      <span className="input-group-text px-3 bg-transparent" id="visibilitySpan"  onClick={togglePassword}>
                            <i className={passwordShown ?"bi bi-eye-slash":"bi bi-eye"} /></span>
                    </CInputGroup>
                    <span className="text-danger small mt-2">{errors.password?.message}</span>
                    {
                      loginError && <div className="text-danger small text-center">{errorMessage}</div>
                    }
                    {networkError ? <p className="text-danger">An error occurred: {networkError.message}</p> : null}
                    <CRow>
                      <CCol xs={6}>
                        <button style={{backgroundColor: "#33C3E9", color: 'white'}} className="px-4 btn btn-lg" type="submit">
                          <div className="d-flex">
                            {isSubmitting && isSubmitting ? `Processing...`:"Sign in"}
                            {isSubmitting && <span className="spinner-grow spinner-grow-sm" />}
                          </div>

                        </button>
                      </CCol>
                      {/*<CCol xs={6} className="text-right">
                        <CButton color="link" className="px-0">
                          Forgot password?
                        </CButton>
                      </CCol>*/}
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
              <CCard className="text-white py-5 cobwebImage" style={{ width: '44%', backgroundColor: '#33C3E9' }}>
                <CCardBody className="text-center">
                  <div>
                    <CImage src={cobwebimg} alt="cobweb image" style={{ width: '270px' }}/>
                  </div>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
};

export default OgaAppLogin;
